module.exports = __webpack_public_path__ + "static/media/18ECA16.0ce550eb.jpg";